export default {
    charities: {
        titleHK: '受惠慈善機構 | 慈善機構',
        descriptionHK: 'NobleWills 不斷為慈善機構在公眾上提高意識，並同時鼓勵客戶捐贈部份遺產幫助不同的慈善機構。',
        keywordsHK: '香港慈善機構, 遺產捐贈, NobleWills 合作伙伴',
        charities: '慈善機構',
        weSupport: '所支持的',
        charityHeading: '慈善捐贈',
        charityBody:
            '透過NobleWills，閣下可輕鬆向本平台合作之認可慈善機構，或任何對閣下別具意義之組織作出捐贈，以延續慈善精神。本網上遺囑平台簡便易用，讓閣下能輕易將慈善捐贈納入遺產規劃。無論閣下選擇捐贈現金或分配部分遺產，只需數次點擊即可完成。',
        charityHeading2: '為何選擇慈善捐贈？',
        charityBody2:
            '在遺囑中加入慈善捐贈，能夠產生持久深遠的影響。此舉不僅能讓閣下所支持之公益事業得以延續，更可因應所在地區及遺產結構而享有稅務優惠。不少客戶均選擇以此慷慨之舉，為後世締造深遠意義。',
        areYou: '成為受惠慈善機構',
        areYouBody: '不妨與我們合作，加入我們的受惠名單，以使我們的客戶可考慮捐贈部分遺產予貴機構。',
        donateToday: '立即捐款',
        donationFigures: '承蒙樂助，至今已有{{currency}}{{million}}遺產將會捐出。',
        charitiesWeSupport: '我們支持的慈善機構',
        charitableGiving: '慈善捐贈',
    },
};
